import {classNames} from '../../support/classnames.ts';
import styles from './identifier.module.scss';
import {Identifier} from './identifier.tsx';
import React, {useCallback, useState} from 'react';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {FlexColumn} from '../utility/flex_column.tsx';
import {IdentifierSize} from '../../support/enums/identifier_size.ts';
import {IdentifierCountry} from '../../support/enums/identifier_country.ts';

interface OwnProps {
    onChange?: (value: string) => void;
}

export function IdentifierSelect({onChange}: OwnProps) {
    const [identifierCountry, setIdentifierCountry] = useState(IdentifierCountry.NL);
    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closeCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closeCallback);

    const onInputChange = (value: string) => {
        if (onChange !== undefined) {
            onChange(value);
        }
        return '';
    };

    return (
        <div
            className={classNames(styles.identifier_select, {
                [styles.open]: isOpen,
            })}
            ref={ref}
        >
            <i className="fa fa-chevron-down" onClick={() => setIsOpen(!isOpen)} />
            <Identifier identifier={''} size={IdentifierSize.Large} identifierCountry={identifierCountry}>
                <input
                    autoFocus={true}
                    name="license_plate_input"
                    onChange={(e) => onInputChange(e.target.value)}
                ></input>
            </Identifier>

            {isOpen && (
                <div className={styles.identifier_select__list}>
                    <FlexColumn>
                        <div
                            className={styles.identifier_wrapper}
                            onClick={() => (setIdentifierCountry(IdentifierCountry.NL), setIsOpen(false))}
                        >
                            {identifierCountry === IdentifierCountry.NL && <i className="fa fa-check" />}
                            <Identifier
                                identifier={'K-313-FT'}
                                size={IdentifierSize.Large}
                                identifierCountry={IdentifierCountry.NL}
                            />
                        </div>
                        <div
                            className={styles.identifier_wrapper}
                            onClick={() => (setIdentifierCountry(IdentifierCountry.DE), setIsOpen(false))}
                        >
                            {identifierCountry === IdentifierCountry.DE && <i className="fa fa-check" />}
                            <Identifier
                                identifier={'BOR BA 989'}
                                size={IdentifierSize.Large}
                                identifierCountry={IdentifierCountry.DE}
                            />
                        </div>
                        <div
                            className={styles.identifier_wrapper}
                            onClick={() => (setIdentifierCountry(IdentifierCountry.B), setIsOpen(false))}
                        >
                            {identifierCountry === IdentifierCountry.B && <i className="fa fa-check" />}
                            <Identifier
                                identifier={'1-AAA-01'}
                                size={IdentifierSize.Large}
                                identifierCountry={IdentifierCountry.B}
                            />
                        </div>
                    </FlexColumn>
                </div>
            )}
        </div>
    );
}
